import { appConfig } from "../app.config";

type BuildSupportUrlParams = {
	locationId?: string | null;
	eventId?: string | null;
	ticketForm?: string;
};

export const buildSupportUrl = ({ locationId, eventId, ticketForm }: BuildSupportUrlParams = {}) => {
	const url = new URL(`${appConfig.HELP_CENTER_URL}/support/tickets/new`);
	url.searchParams.set("support_type", "parker");
	if (ticketForm) {
		url.searchParams.set("ticket_form", ticketForm);
	}
	if (locationId) {
		url.searchParams.set("location", locationId);
	} else if (eventId) {
		url.searchParams.set("event", eventId);
	}
	return url.toString();
};
